import React from 'react';

const CategoryResults = ({ filteredCategory }) => {
  return (
    <ul className="quick-search-result__item-wrapper">
      {filteredCategory &&
        filteredCategory.slice(0, 4).map((item) => (
          <li
            key={`${item.name}-${item.url}`}
            className="quick-search-result__item-wrapper__item"
          >
            <a
              className="quick-search-result__item-wrapper__link"
              href={item.url}
            >
              {item.name}
            </a>
          </li>
        ))}
    </ul>
  );
};

export default CategoryResults;
